import { Link } from "react-router-dom";
import { BarChart3, Calendar, Heart, Package, ShoppingBag } from "lucide-react";
import { useAdminAuth } from "@/hooks/useAdminAuth";

const QUICK_LINKS = [
  {
    to: "/admin/events",
    icon: Calendar,
    title: "Arrangementer",
    description: "Opprett og rediger arrangementer som vises på forsiden.",
  },
  {
    to: "/admin/orders",
    icon: ShoppingBag,
    title: "Ordrer",
    description: "Se og oppdater status på bestillinger fra nettbutikken.",
  },
  {
    to: "/admin/products",
    icon: Package,
    title: "Produkter",
    description: "Endre priser, beskrivelser og lagerstatus på produkter.",
  },
  {
    to: "/admin/donors",
    icon: Heart,
    title: "Fastgivere",
    description: "Oversikt over Vipps-avtaler og månedlige trekk.",
  },
  {
    to: "/admin/analytics",
    icon: BarChart3,
    title: "Analyse",
    description: "Sidevisninger og trafikk fra Vercel Web Analytics.",
  },
];

const AdminDashboard = () => {
  const { user } = useAdminAuth();
  const greetingName = user?.email?.split("@")[0] ?? "der";

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-semibold">Hei, {greetingName}</h1>
        <p className="mt-2 text-muted-foreground">
          Her får du etter hvert oversikt over arrangementer, ordrer og produkter for Håp Naturlab.
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-3">
        {QUICK_LINKS.map((link) => {
          const Icon = link.icon;
          return (
            <Link
              key={link.to}
              to={link.to}
              className="group rounded-lg border bg-card p-6 transition-colors hover:border-primary/40 hover:bg-card/80"
            >
              <div className="flex items-start justify-between">
                <Icon className="h-6 w-6 text-primary" />
              </div>
              <h2 className="mt-4 text-lg font-semibold group-hover:text-foreground">
                {link.title}
              </h2>
              <p className="mt-1 text-sm text-muted-foreground">{link.description}</p>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default AdminDashboard;
